import React from 'react';

const AdminOrders = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Orders Management</h1>
      <p>Manage your orders here</p>
    </div>
  );
};

export default AdminOrders;